import request from '@/utils/request'

// 功能字典（管理员）
export function listFeatures(params) {
  return request({
    url: '/features',
    method: 'get',
    params
  })
}

export function listPublicFeatures(params) {
  return request({
    url: '/features/public',
    method: 'get',
    params
  })
}

export function upsertFeature(data) {
  return request({
    url: '/features',
    method: 'post',
    data
  })
}

export function deleteFeature(id) {
  return request({
    url: `/features/${id}`,
    method: 'delete'
  })
}

// 功能策略（管理员）
export function listFeaturePolicies(params) {
  return request({
    url: '/feature-policies',
    method: 'get',
    params
  })
}

export function replaceFeaturePolicies(data) {
  return request({
    url: '/feature-policies/replace',
    method: 'post',
    data
  })
}

// 当前用户在某 courseTypeCode 下启用的功能（用于前端鉴权）
export function myEnabledFeatures(params) {
  return request({
    url: '/feature-policies/my',
    method: 'get',
    params
  })
}
